module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Audience:\n    ")]), _vm._v(" "), _c('h1', [_vm._v("\n      Total Audience: " + _vm._s(Number(_vm.audienceCount || 0).toLocaleString()) + "\n    ")])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTable),
      expression: "showTable"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-default margin-bottom-0px"
  }, [_c('div', [_c('table', {
    staticClass: "table table-striped table-apps"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.hasRun && _vm.audienceData.length === 0 && !_vm.loading) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v("No Result found.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.audienceData), function(audience, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.audienceData.length),
        expression: "audienceData.length"
      }],
      key: index
    }, [_c('td', [_vm._v(_vm._s(audience.accountId))])])
  })], 2)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Account Id")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-8452686e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/audience-builder/table.vue
// module id = nD1U
// module chunks = 1